module.exports = __webpack_public_path__ + "media/images/landings/promotion_1/flow_img_pc-8d76b00ed14b16309904049c97b91045.png";